const labels = {
  verified: 'Verified',
}

export default labels
